import { HttpClient } from '@lib/HttpClient';
import axios from 'axios';
export async function registerUser(params: Record<string, any>) {
  try {
    const data = await HttpClient.httpPost('/themecartier/resignter', params);
    if (!data) {
      throw new Error('Error: No data returned from register');
    }
    return data;
  } catch (error) {
    console.error('Error in register:', error);
    return 'not ok';
  }
}
export async function loginEmailAndPass(params: Record<string, string>) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const data = await HttpClient.httpGet(`/themecartier/login?${queryParams}`);
    if (!data) {
      throw new Error('Error: No data returned from login');
    }
    return data;
  } catch (error) {
    console.error('Error in loginEmailAndPass:', error);
    return 'not ok';
  }
}
export async function getToken(token: string) {
  try {
    const data = await HttpClient.httpGet(
      `/themecartier/verify/${encodeURIComponent(token)}`
    );
    if (!data) {
      throw new Error('Error: No data returned from token verification');
    }
    return data;
  } catch (error) {
    console.error('Error in getToken:', error);
    return 'not ok';
  }
}
export async function login({
  phone,
  password,
}: {
  phone: string;
  password: string;
}) {
  try {
    const data = await HttpClient.httpPost('/userlogin', { phone, password });
    
    if (!data) {
      throw new Error('Error: No data returned from login');
    }
    
    return data;
  } catch (error) {
    console.error('Error in login:', error);
    
    let message = 'An error occurred while logging in';
    if (typeof error === 'string') {
      try {
        const parsed = JSON.parse(error);
        message = parsed?.error || parsed?.message || message;
      } catch (parseErr) {
        message = String(error);
      }
    } else if (error?.message) {
      message = error.message;
    }
    
    console.error('Login error:', message);
    return 'not ok';
  }
}
export async function createCustomer(data) {
  try {
    const payload = {
      phone: data.phone,
      password: data.password,
      name: data.name,
      email: data.email,
    };

    const result = await HttpClient.httpPost('/customer', payload);
    
    if (!result) {
      throw new Error('Error: No data returned from customer creation');
    }
    
    return result;
  } catch (error) {
    let message = 'An error occurred while creating customer';
    
    if (typeof error === 'string') {
      try {
        const parsed = JSON.parse(error);
        message = parsed?.error || parsed?.message || message;
      } catch (parseErr) {
        message = String(error);
      }
    } else if (error?.message) {
      message = error.message;
    }

    console.error('Error creating customer:', message);
    throw new Error(message);
  }
}
export async function updateCustomer(data) {
  try {
    const token = localStorage.getItem('token'); // Lấy token từ localStorage
    if (!token) {
      return { success: false, error: 'Authorization token is missing' };
    }

    const response = await HttpClient.httpPut(`/customer`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (response.statusCode >= 200 && response.statusCode < 300) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message || 'Update failed' };
    }
  } catch (error) {
    console.error('Error in updateCustomer:', error);
    return { success: false, error: error.message || 'An error occurred' };
  }
}

export async function getCustomer(id) {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Token is missing. Please log in.');
    }
    const responseData = await HttpClient.httpGet(`/customer/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return responseData;
  } catch (error) {
    console.error('Error in getCustomer:', error);
    return 'not ok';
  }
}

export async function updateEmailUser(data, id) {
  try {
    const token = localStorage.getItem('token'); // Lấy token từ localStorage
    if (!token) {
      return { success: false, error: 'Authorization token is missing' };
    }

    const res = await HttpClient.httpPut(
      `/user/${id}`,
      {
        name: data.name,
        email: data.email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.statusCode >= 200 && res.statusCode < 300) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res.message || 'Update failed' };
    }
  } catch (error) {
    console.error('Error in updateEmailUser:', error);
    return { success: false, error: error.message || 'An error occurred' };
  }
}

export async function getUser(id) {
  const token = localStorage.getItem('token');
  try {
    const responseData = await HttpClient.httpGet(`/user/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return responseData;
  } catch (error) {
    console.error('Error in get User:', error);
    return 'not ok';
  }
}

export async function sendOTP(email: string) {
  try {
    const responseData = await HttpClient.httpPost("/user/send-otp", 
      { email }, // Gửi email vào body
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return responseData;
   
  } catch (error) {
    console.error("Error in sendOTP:", error);
    return { success: false, message: "Có lỗi xảy ra, vui lòng thử lại!" };
  }
}


export async function resetPassword(email: string, otp: string, newPassword: string, storedOtpExpire:number,storedOtp:string) {
  try {
    const responseData = await HttpClient.httpPut("/user/reset-password", { 
      email, 
      otp, 
      storedOtp,
      storedOtpExpire,
      newPassword
    }, {
      headers: { "Content-Type": "application/json" },
    });
    return responseData;
  } catch (error) {
    console.error("Error in resetPassword:", error);
    return { success: false, message: "Có lỗi xảy ra, vui lòng thử lại!" };
  }
}

 
/**
 * Decode the CRM JWT stored in localStorage under `crm_access_token`.
 * Returns the decoded payload object or null if not present / invalid.
 */
export function decodeCrmToken(): any | null {
  try {
    if (typeof window === 'undefined') return null;
    const token = localStorage.getItem('crm_access_token');
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    // base64url -> base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    const padded = pad ? base64 + '='.repeat(4 - pad) : base64;
    let json = '';
    if (typeof atob === 'function') {
      // browser
      try {
        // decode percent-encoding safe
        const binary = atob(padded);
        json = decodeURIComponent(
          Array.prototype.map.call(binary, function (c: string) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join('')
        );
      } catch (e) {
        // fallback to direct atob
        json = atob(padded);
      }
    } else if (typeof Buffer !== 'undefined') {
      // Node environment
      json = Buffer.from(padded, 'base64').toString('utf8');
    } else {
      return null;
    }
    return JSON.parse(json);
  } catch (e) {
    console.error('decodeCrmToken error:', e);
    return null;
  }
}

/**
 * Fetch full CRM user profile using ID decoded from `crm_access_token`.
 * Calls: GET http://localhost:3100/api/users/:id/full with Authorization header.
 * Returns response data or 'not ok' on error.
 */
export async function fetchCrmUserFull(): Promise<any> {
  try {
    if (typeof window === 'undefined') {
      throw new Error('Client-only function: window is not available');
    }
    const token = localStorage.getItem('crm_access_token');
    if (!token) {
      throw new Error('CRM access token not found in localStorage');
    }
    const decoded = decodeCrmToken();
    const id = decoded?.id || decoded?.sub || decoded?.userId || (decoded && decoded.user && decoded.user.id) || null;
    if (!id) {
      throw new Error('Unable to determine CRM user id from token payload');
    }

  const CRM_API_BASE = (
    process.env.NEXT_PUBLIC_CRM_API_BASE ||
    (process.env.NODE_ENV === 'production' ? 'https://loyalty.gurusolutions.vn/api' : 'http://localhost:3100/api')
  ).replace(/\/$/, '');
  const url = `${CRM_API_BASE}/users/${encodeURIComponent(String(id))}/full`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });
    return res?.data ?? res;
  } catch (error) {
    console.error('Error fetching CRM user full:', error);
    return 'not ok';
  }
}

/**
 * Change user password
 * @param currentPassword - The current password
 * @param newPassword - The new password
 * @param confirmPassword - Confirmation of new password
 * @returns Response data or error object
 */
export async function changePassword(payload: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return { success: false, error: 'Authorization token is missing' };
    }

    // Get user from localStorage
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return { success: false, error: 'User information is missing' };
    }
    
    const user = JSON.parse(userStr);
    const userId = user?.id;
    
    if (!userId) {
      return { success: false, error: 'User ID not found' };
    }

    const response = await HttpClient.httpPut(
      '/user/change-password',
      {
        userId: userId,
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
        confirmPassword: payload.confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // Check if response has success property (direct from backend)
    if (response.success === true) {
      return { success: true, data: response.data, message: response.message };
    }
    
    // Fallback: check statusCode
    if (response.statusCode >= 200 && response.statusCode < 300) {
      return { success: true, data: response.data, message: response.message };
    }
    
    return { success: false, error: response.message || 'Change password failed' };
  } catch (error) {
    console.error('Error in changePassword:', error);
    return { 
      success: false, 
      error: error?.message || 'An error occurred while changing password' 
    };
  }
}

